<div class="main-popup mt-5">
    <div class="main-title-popup mb-4">
        <h1>ODO average weight</h1>
        <p>Details for ODO Average Weight</p>
    </div>
    <form [formGroup]="odoForm" (ngSubmit)="onSubmit()">

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="weight">ODO average weight(gram)<span class="text-danger-required">*</span></label>
                    <input id="odoAverageWeight" class="form-control" [ngClass]="{
                        'is-invalid': isControlInvalid('weight'),
                        'is-valid': !isControlInvalid('weight') && odoForm.get('weight').touched
                      }" type="text" formControlName="weight" placeholder="Please enter average weight" />
                    <div *ngIf="odoForm.get('weight').invalid && odoForm.get('weight').touched" class="text-danger">
                        please add number of chicks
                    </div>
                    <span class="text-danger" *ngIf="odoForm.get('weight').errors?.min">Value must be
                        non-negative.</span>
                </div>
            </div>
        </div>
        <div class="col-md-12 text-right">
            <button class="btn btn-primary" type="submit" [disabled]="isLoading$ | async">
                <span *ngIf="!isAuthLoading">Submit</span>
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
            <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
            
        </div>
    </form>
</div>